import React, { useState } from 'react';
import _, { get as _get } from 'lodash-es';
import { optionData, backingProducts } from '../utils/Constants';

const AdditionalOptions = ({
  optionsDetails,
  setOptionsDetails,
  productDetails,
  popupType,
  isParentReel,
}) => {
  const handleOptionChange = e => {
    const currentOptions = { ...selectedOptions };
    let currentBacking = optionsDetails.backingProduct;
    currentOptions[`${e.target.name}`] = e.target.value;
    if (
      currentOptions.backing_option &&
      currentOptions.backing_option !== 'No Backing'
    ) {
      if (
        optionsDetails.details.backing_option !== currentOptions.backing_option
      ) {
        currentBacking = backingProducts.find(
          item => item.name === currentOptions.backing_option
        ).variantId;
      }
    } else {
      currentBacking = ' ';
    }
    setSelectedOption(currentOptions);
    setOptionsDetails({
      show: true,
      details: currentOptions,
      backingProduct: currentBacking,
    });
  };

  let defaultSelection = {};
  optionData.forEach(element => {
    defaultSelection[element.optionId] = element.options[0].value;
  });
  const [selectedOptions, setSelectedOption] = useState(defaultSelection);

  const OptionData = optionData.map(singleOption => {
    if (singleOption.optionType === 'radio')
      return (
        <div key={singleOption.optionId} className="xcs-option-lable">
          <label>
            <strong>{singleOption.optionDescription}</strong>
          </label>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {singleOption.options.map(ol => {
              return (
                <label key={ol.label}>
                  <input
                    type="radio"
                    name={singleOption.optionId}
                    value={ol.value}
                    checked={
                      selectedOptions[singleOption.optionId] === ol.value
                    }
                    onChange={handleOptionChange}
                  />
                  {ol.label}
                </label>
              );
            })}
          </div>
        </div>
      );
    if (singleOption.optionType === 'dropdown')
      return (
        <div key={singleOption.optionId} className="xcs-option-lable">
          <label>
            <strong>{singleOption.optionDescription}</strong>
          </label>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {singleOption.options.length > 1 ? (
              <select
                value={selectedOptions[singleOption.optionId]}
                className="xrsselect"
                onChange={handleOptionChange}
                name={singleOption.optionId}
              >
                {singleOption.options.map(variantOption => (
                  <option
                    id={variantOption.value}
                    value={variantOption.value}
                    key={variantOption.value}
                    className="xrs-product__option-text"
                  >
                    {variantOption.value}
                  </option>
                ))}
              </select>
            ) : null}
          </div>
        </div>
      );
  });
  if (optionsDetails.show) {
    return (
      <div
        style={optionsDetails.show ? {} : { display: 'none' }}
        className="details-modal__container"
      >
        {popupType !== 'reelsoptions' && popupType !== 'xrsoptions' ? (
          <button
            className="bundler-button"
            onClick={() => {
              setOptionsDetails({ show: false });
            }}
          >
            <i className="arrow left" /> BACK
          </button>
        ) : null}
        <div className="details-modal">
          <div className="details-modal__name">
            {!isParentReel ? <p>{productDetails.productName}</p> : null}
          </div>
          <div className="xrsbundler-container" style={{ display: 'flex' }}>
            {/* {!isParentReel ? (
              <div className="details-modal__image-desc">
                <img
                  src={
                    productDetails.productImage
                      ? productDetails.productImage
                      : productDetails.url_image
                  }
                  alt={productDetails.variantName}
                  className="xrs-product__image"
                  width="100px"
                  height="100px"
                />
              </div>
            ) : null} */}
            <div className="xrs-options">
              <label>Please specify these options:</label>
              {OptionData}
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
};
export default AdditionalOptions;
